import { ref } from "vue";
import type { TimeRange } from "../types/api";

export const RANGE_OPTIONS: ReadonlyArray<{ id: TimeRange; label: string }> = [
  { id: "24h", label: "24 小时" },
  { id: "7d", label: "7 天" },
  { id: "30d", label: "30 天" },
  { id: "1y", label: "1 年" }
];

export const RANGE_LABELS = Object.fromEntries(
  RANGE_OPTIONS.map((option) => [option.id, option.label])
) as Record<TimeRange, string>;

/**
 * One range for every history chart on the page: whoever switches to seven days on one
 * chart almost always wants the next chart they open to show seven days too.
 */
export const historyRange = ref<TimeRange>("24h");
